export {BatchRpcService} from './batch.rpc.service'

export interface BatchQuickEdit {
  editType?: QuickEditType | null;
  batches?: string[];
  shipped?: boolean | null;
  status?: number | null;
  tags?: string[] | null;
  order_numbers?: string[] | null;
  inland_bol?: string[] | null;
  container_numbers?: string[] | null;
  eta?: string | null;
  notes?: string | null;
}

export enum QuickEditType {
  ShippingStatus = 0,
  Status = 1,
  Tags = 2,
  Eta = 3,
  OrderNumbers = 4,
  Notes = 5,
  ContainerNumbers = 6,
  InlandBOL = 7
}

export enum IStatus {
  Temporary = 2,
  Draft = 3,
  Run = 4,
  Accepted = 5,
  Released = 6,
  Issue = 19,
  Created = 24,
  Opened = 25,
  Completed = 33,
  Billing = 34,
  Recovered = 35
}

export interface StatusOptions {
  primary: string,
  accent: string,
  label: string,
}

export function getStatusOptions(status: IStatus): StatusOptions {
  let options: StatusOptions = {
    primary: '#F2F4F7',
    accent: '#667085',
    label: 'Not Applicable',
  }
  switch (status) {
    case IStatus.Run:
      options.label = 'Run';
      break;
    case IStatus.Accepted:
      options.primary = '#EFF8FF';
      options.accent = '#175CD3';
      options.label = 'Released';
      break;
    case IStatus.Released:
      options.primary = '#EFF8FF';
      options.accent = '#175CD3';
      options.label = 'Released';
      break;
    case IStatus.Issue:
      options.primary = '#FEF3F2';
      options.accent = '#B42318';
      options.label = 'Issue';
      break;
    case IStatus.Created:
      options.label = 'Created';
      break;
    case IStatus.Opened:
      options.primary = '#ECFDF3';
      options.accent = '#027948';
      options.label = 'Opened';
      break;
    case IStatus.Completed:
      options.primary = '#ECFDF3';
      options.accent = '#027948';
      options.label = 'Completed';
      break;
    case IStatus.Billing:
      options.label = 'Billing';
      break;
    case IStatus.Recovered:
      options.label = 'Recovered';
      break;
  }
  return options;
}

export enum IGovStatus {
  FdaReview = 10,
  FdaMayProceed = 11,
  FdaHold = 12,
  FdaSample = 13,
  NOAAMayProceed = 14,
  USDAHold = 15,
  NOAAReview = 23,
  USDAReview = 26,
  CBPReview = 27,
  USDAMayProceed = 28,
  CBPMayProceed = 29,
  NOAAHold = 31,
  CBPHold = 32
}

export interface Status {
  bsid: number;
  label: string;
  type: number;
}

export enum BatchActions {
  UpdateBatchDocuments = "UpdateBatchDocuments",
  CreateBatchDocuments = "CreateBatchDocuments",
  BatchesMajorityShippedStatus = "BatchesMajorityShippedStatus",
  ProcessQuickEdits = "ProcessQuickEdits",
  GetStatuses = "GetStatuses",
  GetBatch = "GetBatch",
  ExportBatches = "ExportBatches",
  GetBatches = "GetBatches",
  GetLatestBatch = "GetLatestBatch",
  GetBatchList = "GetBatchList",
  Bookmark = "Bookmark",
  Get = "Get"
}

export interface Batch {
  bid: string
  parent_bid: string
  shipped: boolean
  bookmarked: boolean
  barcodes: string[]
  order_number: string[]
  tags: string[]

  awb_bol_number: string
  container_number: string
  estimated_date_arrival: string
  reference_number: string
  log_code: string

  updated_on: string

  status: string

  importers: string
  suppliers: string
  truckers: string
  pilot: string

  courier_type: boolean
}

